import {
  DEMO_TEST_PARTNER_TENANT_ID,
  VRP_TENANT_ID,
  XIMPLIFI_TENANT_ID,
} from '@vrplatform/graphql';
import { GL_HYPERLINE_PARTNER_PLAN_NAME } from '@vrplatform/hyperline-client';
import { useContext, useMemo } from 'react';
import { teamContext, useMe } from './team';
import { useIsPlaywright } from './usePlaywright';

export function useBilling() {
  const { team } = useContext(teamContext);
  const { email: userEmail } = useMe();

  const isPlaywright = useIsPlaywright(userEmail);

  return useMemo(() => {
    const isVrpCustomer =
      team.billingPartnerId === VRP_TENANT_ID &&
      team.id !== VRP_TENANT_ID &&
      team.id !== XIMPLIFI_TENANT_ID;

    const isPlaywrightDemo =
      team.billingPartnerId === DEMO_TEST_PARTNER_TENANT_ID && isPlaywright;

    const isAccountingPartner =
      team.type === 'partner' &&
      team.id !== VRP_TENANT_ID &&
      team.id !== XIMPLIFI_TENANT_ID;

    const isXimplifiCustomer = team.billingPartnerId === XIMPLIFI_TENANT_ID;

    // show billing for
    // 1. child teams of VRP partner team
    // 2. All partner teams that or not VRP
    const showBilling =
      (isVrpCustomer || isAccountingPartner || isXimplifiCustomer) &&
      !!team?.subscription.status;

    const isReadOnly = team.status === 'inactive' && showBilling;
    const isVRTrustPartner =
      team.subscription.plan === GL_HYPERLINE_PARTNER_PLAN_NAME;

    return {
      showBilling,
      isReadOnly,
      isXimplifiCustomer,
      isVRTrustPartner,
      subscription: team.subscription,
      isVrpCustomer,
      isPlaywrightDemo,
    };
  }, [
    team.subscription,
    team.status,
    team.billingPartnerId,
    team.type,
    team.id,
    isPlaywright,
  ]);
}
